import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function EmployeeDetails() {
  const { id } = useParams();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://hrms.urbango.co.in/server/index.php?endpoint=employee_profile_id&id=${id}`)
      .then((res) => res.json())
      .then((data) => {
        setEmployee(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!employee) return <div>Employee not found</div>;

  return (
    <div className="profile-card">
      <h3 className="profile-title">Employee Details</h3>
      <p><strong>Name:</strong> {employee.employeeName}</p>
      <p><strong>Employee No:</strong> {employee.employeeNo}</p>
      <p><strong>Email:</strong> {employee.officialEmail}</p>
      <p><strong>Blood Group:</strong> {employee.bloodGroup}</p>
      <p><strong>Phone:</strong> {employee.phoneNumber}</p>
      <p><strong>Address:</strong> {employee.address}</p>
    </div>
  );
}

export default EmployeeDetails;
